import React from 'react';
import { Theme } from '../theme';
import { Icon } from './icons';

/**
 * Light/dark switch. `icon` is a compact square button, `row` is a full-width
 * button with a text label (used in the sidebar / mobile menu).
 */
const ThemeToggle: React.FC<{ theme: Theme; onToggle: () => void; variant?: 'icon' | 'row' }> = ({ theme, onToggle, variant = 'icon' }) => {
    const toLight = theme === 'dark';
    const label = toLight ? 'Włącz jasny motyw' : 'Włącz ciemny motyw';
    return (
        <button
            type="button"
            className={variant === 'row' ? 'ghost-btn' : 'theme-toggle'}
            onClick={onToggle}
            title={label}
            aria-label={label}
        >
            <Icon name={toLight ? 'sun' : 'moon'} />
            {variant === 'row' && <span>{toLight ? 'Jasny motyw' : 'Ciemny motyw'}</span>}
        </button>
    );
};

export default ThemeToggle;
